module.exports = __webpack_public_path__ + "static/media/mkr.176ebc85.png";